const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconMegafono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.93 14.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_megafono",
    "data-name": "Icon megafono"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,12.47c-.18.37-.36.73-.55,1.09a.52.52,0,0,1-.66.36L3,13.44a.5.5,0,0,1-.41-.74c.19-.47.4-.94.6-1.41,0-.07.06-.14.1-.26-.18,0-.34-.07-.49-.07H.63C.18,11,0,10.77,0,10.31V4.61C0,4.14.18,3.94.65,4a12.33,12.33,0,0,0,4.58-.66C8.86,2.18,12.51,1.13,16.15.05c.53-.15.8,0,.8.59V14.28c0,.55-.27.75-.8.59L8.26,12.54Zm7.91,1.29V1.17l-.19,0C12.15,2.28,8.57,3.32,5,4.41A9.78,9.78,0,0,1,1.24,5,.91.91,0,0,0,1,5v5H2.74a2.42,2.42,0,0,1,.6.09l10.5,3.11ZM3.71,12.53l.39.05,2.38.3c.08,0,.21,0,.24-.06.12-.2.22-.42.33-.65l-2.83-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.94,8V3.05a.51.51,0,0,1,.56-.57.5.5,0,0,1,.43.5c0,.31,0,.62,0,.93v8.81a2.26,2.26,0,0,1,0,.26.49.49,0,0,1-.47.46.52.52,0,0,1-.52-.44V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.93,8v3.8a1.93,1.93,0,0,1,0,.24.51.51,0,0,1-.5.43A.48.48,0,0,1,20,12c0-.29,0-.58,0-.87v-7a.86.86,0,0,1,0-.32.46.46,0,0,1,.55-.28.5.5,0,0,1,.39.51V8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMegafono);
export default __webpack_public_path__ + "static/media/Icon_megafono.504d31c81cebd649ee91294dc8c4afb7.svg";
export { ForwardRef as ReactComponent };